import { Config } from '../Config';
import React, { useEffect } from 'react';
import Fnc from '../library/Functions';

export function StepsViewer(props) {

  const basketTitle = "Acquisto completato";
  const prevTitle = "Richiedi il tuo preventivo gratuito";


  useEffect(() => {

    Fnc.log("BSK TYPE", props.bskType, Fnc.LogLvl.DEBUG);

  }, [props.selComm, props.currStep, props.bskType]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento


  function getStepsToPrint() {
    let steps = Config.stepList.filter(s => {
      if (props.bskType === Fnc.BasketType.BOTH) {
        return true;
      } else if (props.bskType === Fnc.BasketType.PAY) {
        return s.bskType === Fnc.BasketType.PAY || s.bskType === Fnc.BasketType.BOTH;
      } else {
        //PREV
        return s.bskType === Fnc.BasketType.PREV || s.bskType === Fnc.BasketType.BOTH;
      }
    });
    Fnc.log("CURR STEPS TO PRINT:", steps, Fnc.LogLvl.DEBUG);
    return steps;
  }


  function getStepDesc(idx) {
    const currStep = Config.stepList.find(function (el) {
      return el.idx === idx;
    })
    if (props.bskType === Fnc.BasketType.BOTH) {
      return currStep.desc;
    } else if (props.bskType === Fnc.BasketType.PAY) {
      return currStep.desc;
    } else {
      //PREV
      return currStep.descPrev;
    }
  }

  
  function getBasketDesc() {
    if (props.bskType === Fnc.BasketType.BOTH) {
      return basketTitle;
    } else if (props.bskType === Fnc.BasketType.PAY) {
      return basketTitle;
    } else {
      //PREV
      return prevTitle;
    }
  }

  return (
    <>

      <div className="iol-checkout-container">
        <h1 className="heading-1">{getBasketDesc()}</h1>
        {(props.user && props.user.response && props.user.response.code === "OK") &&
          <>
            <div className="link">id commissione</div>
            <div className="caption">{props.selComm ? props.selComm.codComm : ""}</div>
          </>
        }
      </div>

      <div className="iol-checkout-container">
        <ul className="progressbar row">
          {getStepsToPrint().map((step, index) => (
            <React.Fragment key={step.idx}>
              {(step.enabled && props.currStep.idx > step.idx) &&
                <li key={step.idx} className="col-3 col-md-3 col-lg-4">
                  <div key={step.idx} className="iol-step completed" href="#">
                    <div key={step.idx} className="step-text">{getStepDesc(step.idx)}</div>
                  </div>
                </li>
              }
              {(step.enabled && props.currStep.idx === step.idx) &&
                <li key={step.idx} className="col-6 col-md-5 col-lg-4">
                  <div key={step.idx} className="iol-step active" href="#">
                    <div key={step.idx} className="step-text">{getStepDesc(step.idx)}</div>
                  </div>
                </li>
              }
              {(step.enabled && props.currStep.idx < step.idx) &&
                <li key={step.idx} className="col-3 col-md-3 col-lg-4">
                  <div key={step.idx} className="iol-step" href="#">
                    <div key={step.idx} className="step-text">{getStepDesc(step.idx)}</div>
                  </div>
                </li>
              }
            </React.Fragment>
          ))}

        </ul>
      </div>
    </>
  );
}
